import React, { Component } from 'react'
import AppBar from 'material-ui/AppBar'
import RaisedButton from 'material-ui/RaisedButton'
import TextField from 'material-ui/TextField'
import Snackbar from 'material-ui/Snackbar'
import axios from 'axios'

class Login extends Component {
  constructor(props) {
    super(props)
    console.log(sessionStorage.user)

    this.state = {
      username:'',
      password:'',
      snackOpen: false,
      snackMessage: '',
    }
  }

  componentWillMount(){
    console.log("willmount prop values",this.props)
  }

  handleSnackClose = () => {
    this.setState({
      snackOpen: false,
      snackMessage: ''
    })
  }

  render() {
    return (
      <div style={style.root}>
        <AppBar
           title="アクセス管理画面"
           showMenuIconButton={false}
        />
        <div>
          <TextField
            hintText="ユーザ名を入力してください。"
            floatingLabelText="ユーザ名"
            onChange={(e,val) => this.setState({username:val})}
          />
          <br/>
          <TextField
            type="password"
            hintText="パスワードを入力してください。"
            floatingLabelText="パスワード"
            onChange={(e,val) => this.setState({password:val})}
            onKeyPress={this.catchEnter}
          />
          <br/>
          <RaisedButton label="ログイン" primary={true} style={style.button} onClick={(e) => this.handleClick(e)}/>
        </div>
        <Snackbar
          open={this.state.snackOpen}
          message={this.state.snackMessage}
          autoHideDuration={2000}
          onRequestClose={this.handleSnackClose}
        />
      </div>
    )
  }

  catchEnter = (e) => {
    if (e.charCode === 13) {
      e.preventDefault()
      this.handleClick(e)
    }
  }

  handleClick = (e) => {
    var payload = {
      "username":this.state.username,
      "password":this.state.password,
    }
    axios.post('/api/login', payload)
    .then((response) => {
      console.log(response)
      if (response.data.ok === 'ok') {
        sessionStorage.user = response.data.user
        window.location.href = '/'
      } else {
        this.setState({
          snackOpen: true,
          snackMessage: response.data.message,
        })
      }
    })
    .catch((error) => {
      console.log(error)
      this.setState({
        snackOpen: true,
        snackMessage: 'ログインに失敗しました。',
      })
    })
  }
}

const style = {
  root: {
    textAlign: 'center'
  },
  button: {
    margin: 15
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/pages/Login.js